import type { ChangeEvent } from 'react'
import { Button, Input, Label } from '@/shared/ui/primitives'
import type { CreateProCrew, SendCrewInvite } from '@/modules/auth/use-cases'
import { CrewHeroCard } from './crew-hero-card'
import { CrewInviteStep } from './crew-invite-step'
import { useCrewNameStep } from './use-crew-name-step'

export type CrewNameStepProps = {
  onCreateProCrew: CreateProCrew
  onSendCrewInvite: SendCrewInvite
  onProRequired: () => void
  onCreated?: () => void
  fullBleed?: boolean
}

export function CrewNameStep(props: CrewNameStepProps) {
  const vm = useCrewNameStep(props)

  if (vm.createdOrgId) {
    return (
      <CrewInviteStep
        orgId={vm.createdOrgId}
        onSendCrewInvite={props.onSendCrewInvite}
        onDone={vm.finish}
        fullBleed={props.fullBleed}
      />
    )
  }

  return (
    <CrewHeroCard
      testId="step-crewName"
      title="Name your crew"
      subtitle="Pick a name your buddies will recognize. You can rename it anytime."
      fullBleed={props.fullBleed}
    >
      <form
        onSubmit={vm.handleSubmit}
        className="flex flex-col gap-4"
        data-testid="crew-name-form"
        noValidate
      >
        <div className="flex flex-col gap-1">
          <Label htmlFor="crew-name">Crew name</Label>
          <Input
            id="crew-name"
            value={vm.name}
            onChange={(e: ChangeEvent<HTMLInputElement>) => vm.setName(e.target.value)}
            disabled={vm.isCreated}
            autoComplete="off"
            placeholder="e.g. Marsh Rats"
          />
          {vm.error ? (
            <p role="alert" className="text-xs text-destructive">
              {vm.error}
            </p>
          ) : null}
        </div>
        <Button
          type="submit"
          disabled={vm.isSubmitting || vm.isCreated}
          className="h-auto w-full rounded-lg py-3.5 text-base font-semibold"
        >
          Create crew
        </Button>
        <p className="text-center text-xs text-muted-foreground">
          Free to create · You'll be the crew's first member
        </p>
      </form>
    </CrewHeroCard>
  )
}
